import { FC } from 'react';

import Layout from 'components/Layout';

const App: FC = () => (
  <div className='App'>
    <Layout />
  </div>
);

export default App;
